import React from 'react';
import cn from 'classnames';
function PageTitle(_a) {
    var title = _a.title, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React.createElement("h1", { className: cn("text-2xl", className) }, title));
}
export default PageTitle;
